import './js/slider';
//import '../assets/css/index.css';

import { init } from 'litelight-js';
init();

const siteHeader = document.querySelector('header.site-header');
const menuTrigger = document.querySelector('.menuTrigger');
menuTrigger.addEventListener('click', () => {
    siteHeader.classList.toggle('is-open');
});

// Add scroll event listener to header to add .scroll class if scrolled down more than 100px
window.addEventListener('scroll', () => {
    if (window.scrollY > 40) {
        siteHeader.classList.add('scroll');
    } else {
        siteHeader.classList.remove('scroll');
    }
});

// close menu layer when clicking .menu links
const menuLinks = document.querySelectorAll('header.site-header .menu a');
menuLinks.forEach(link => {
    link.addEventListener('click', () => {
        siteHeader.classList.remove('is-open');
    });
});
var map = L.map('map').setView([59.428674, 24.430448], 15);

L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
}).addTo(map);

map.scrollWheelZoom.disable();

var LeafIcon = L.Icon.extend({
    options: {
        iconSize:     [180, 60],
        iconAnchor:   [22, 94],
        popupAnchor:  [-3, -76]
    }
});

var pringiIcon = new LeafIcon({
    iconUrl: themeData.siteUrl + '/wp-content/themes/paikesekivitheme/assets/img/icon-marker.svg'
})

L.marker([59.428674, 24.430448], {icon: pringiIcon}).addTo(map);

let plotsRows = document.querySelectorAll('.plots_table tr');
if (plotsRows) {

    plotsRows.forEach(function(plotsRow) {
        plotsRow.addEventListener('mouseover', function() {
            let areaElement = document.querySelector('g#' + this.id + '.area');
            if (!areaElement) {
                return;
            }
            if (!this.classList.contains('available')) {
                areaElement.classList.add('booked');
            } else {
                areaElement.classList.add('active');
            }
        })
        plotsRow.addEventListener('mouseout', function() {
            let areaElement = document.querySelector('g#' + this.id + '.area');
            if (!areaElement) {
                return;
            }
            areaElement.classList.remove(this.classList.contains('available') ? 'active' : 'booked');
        })
    })



    document.querySelectorAll('.plots_layer g.area').forEach(function(area) {
        let areaEl = document.querySelector('tr#' + area.id);
        if (!areaEl) {
            return;
        }
        area.addEventListener('mouseover', function() {
            areaEl.classList.add('active');
        })
        area.addEventListener('mouseout', function() {
            areaEl.classList.remove('active');
        })
    });
}

// modal
let plotsModal = document.getElementById('plotsModal');
if (plotsModal) {
    document.querySelectorAll('.map-link').forEach((mapLink) => {
        mapLink.addEventListener('click', function(e) {
            e.preventDefault();
            plotsModal.querySelectorAll('.area').forEach((area) => {
                ['active', 'booked'].forEach(className => area.classList.remove(className));
            })

            let selectedPlot = this.closest('tr');
            if (selectedPlot) {
                if (selectedPlot.classList.contains('available')) {
                    plotsModal.querySelector('#plotsModal g#' + selectedPlot.id + '.area').classList.add('active');
                } else {
                    plotsModal.querySelector('#plotsModal g#' + selectedPlot.id + '.area').classList.add('booked');
                }
            }
            plotsModal.classList.add('visible');
        })
    })
}
/*
document.querySelectorAll('.plots_table .map-link').forEach(function(mapLink) {
        mapLink.addEventListener('click', function(e) {
            e.preventDefault();

            // remove active class from all areas in modal
            plotsModal.querySelectorAll('.plots_layer g.area').forEach(function(area) {
                area.classList.remove('active');
            });
            let areaElement = document.querySelector('#plotsModal g#' + this.closest('tr').id + '.area');
            if (!areaElement) {
                return;
            }

            areaElement.classList.add('active');
        })
    });
 */

document.querySelectorAll('.modal .close').forEach(function (el) {
    el.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector('.modal').classList.remove('visible');
    });
});

let contactLinks = document.querySelectorAll('table .contact');
let contactSelect = document.getElementById('select-plot');

if (contactLinks) {
    contactLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            contactSelect.value = this.dataset.addr;
            window.scrollTo({
                top: document.querySelector('footer.contact').offsetTop,
                left: 0,
                behavior: 'smooth'
            });
        })
    })
}

